import { Checkbox, FormControlLabel, withStyles } from '@material-ui/core';
import React from 'react';
import StyledToolTip from '../../../../../common/StyledToolTip';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const styles = (theme) => ({
  checkboxLabel: {
    paddingRight: 32,
    backgroundColor: theme.radioLabel,
    margin: 0
  },
  radioLabelText: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 400,
    color: theme.radioLabelText
  },
  checkBox: {
    color: theme.checkboxColor
  },
  active: {
    backgroundColor: theme.activeRadioBG
  },
  disabled: {
    backgroundColor: theme.disableButtonBG,
    cursor: 'not-allowed',
    '& $checkBox': {
      color: theme.disableButtonText
    },
    '& $radioLabelText': {
      color: theme.disableButtonText
    }
  },
  selectedCheckboxLabelText: {
    color: theme.selectedRadioLabelText
  },
  checkBoxIcon: {
    color: theme.radioIconColor
  },
  labelElement: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  }
});

const CustomCheckbox = ({
  classes,
  name,
  labelText,
  disabled,
  isChecked,
  handleChange,
  tooltip,
  tooltipIcon
}) => {
  return (
    <FormControlLabel
      key={`dynamic_checkbox_group_${name}`}
      classes={{
        root: `${classes.checkboxLabel} ${isChecked ? classes.active : ''}`,
        label: `${classes.radioLabelText} ${isChecked ? classes.selectedCheckboxLabelText : ''}`,
        disabled: classes.disabled
      }}
      disabled={disabled}
      control={
        <Checkbox
          classes={{ root: classes.checkBox, disabled: classes.disabled }}
          checked={isChecked}
          onChange={handleChange}
          name={name}
          color="primary"
          className={isChecked ? '' : classes.checkBoxIcon}
          disabled={disabled}
        />
      }
      label={
        <div className={classes.labelElement}>
          <span>{labelText}</span>
          {Boolean(tooltip) && (
            <StyledToolTip title={tooltip}>{tooltipIcon || <InfoOutlinedIcon />}</StyledToolTip>
          )}
        </div>
      }
    />
  );
};

export default withStyles(styles)(CustomCheckbox);
